import { render, staticRenderFns } from "./CVideo.vue?vue&type=template&id=7c5f484a&"
import script from "./CVideo.vue?vue&type=script&lang=js&"
export * from "./CVideo.vue?vue&type=script&lang=js&"
import style0 from "./CVideo.vue?vue&type=style&index=0&lang=scss&scope=true&"
import style1 from "./CVideo.vue?vue&type=style&index=1&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports